import React from 'react';
import gettext from '@eb/gettext';

import Banner from './Banner';

export const CORONAVIRUS_HEADER = gettext("We're here to help");
export const CORONAVIRUS_BODY = gettext(
    'See our latest COVID-19 resources to stay safe and manage your events - for <a href="/l/coronavirus-resources-event-attendees/">attendees</a> and <a href="/l/coronavirus-resources-event-organizers/">creators</a>.',
);

export const CoronaVirusBanner = () => (
    <Banner leftAccentColor="#F05537" header={CORONAVIRUS_HEADER}>
        <span
            //eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: CORONAVIRUS_BODY,
            }}
        />
    </Banner>
);

CoronaVirusBanner.propTypes = {};

export default CoronaVirusBanner;
